export function buildAnalogies(totalSeconds: number): string[] {
  const s = Math.max(0, Math.floor(totalSeconds));
  const fmt = (n: number) => new Intl.NumberFormat().format(n);

  // Units (approximate; intentionally simple & fun)
// Units (approximate; intentionally simple & fun)
const CATALOG = [
  // Movies & TV
  { label: 'Titanic viewings (3h15m)', sec: 195 * 60 },
  { label: 'The Lion King (1994) viewings (88m)', sec: 88 * 60 },
  { label: 'Return of the King extended cut (201m)', sec: 201 * 60 },
  { label: 'Avengers: Endgame viewings (181m)', sec: 181 * 60 },
  { label: 'Interstellar viewings (169m)', sec: 169 * 60 },
  { label: 'The Godfather viewings (175m)', sec: 175 * 60 },
  { label: 'The Shawshank Redemption viewings (142m)', sec: 142 * 60 },
  { label: 'Inception viewings (148m)', sec: 148 * 60 },
  { label: 'The Matrix viewings (136m)', sec: 136 * 60 },
  { label: 'Star Wars: A New Hope viewings (121m)', sec: 121 * 60 },
  { label: 'Oppenheimer viewings (180m)', sec: 180 * 60 },
  { label: 'Barbie viewings (114m)', sec: 114 * 60 },
  { label: 'Frozen viewings (102m)', sec: 102 * 60 },
  { label: 'Avatar viewings (162m)', sec: 162 * 60 },
  { label: 'Friends episodes (~22m)', sec: 22 * 60 },
  { label: 'The Office episodes (~20m)', sec: 20 * 60 },
  { label: 'Game of Thrones episodes (~60m)', sec: 60 * 60 },
  { label: 'Breaking Bad episodes (~47m)', sec: 47 * 60 },
  { label: 'Simpsons episodes (~23m)', sec: 23 * 60 },
  { label: 'Stranger Things episodes (~50m)', sec: 50 * 60 },
  { label: 'Succession episodes (~60m)', sec: 60 * 60 },
  { label: 'The Last of Us episodes (~70m)', sec: 70 * 60 },

  // Everyday & Work
  { label: 'Pomodoro focus sessions (25m)', sec: 25 * 60 },
  { label: 'coffee brews in a French press (4m)', sec: 4 * 60 },
  { label: 'kettle boils (3m)', sec: 3 * 60 },
  { label: 'toothbrushing sessions (2m)', sec: 2 * 60 },
  { label: 'hand-washes (20s)', sec: 20 },
  { label: 'daily standups (15m)', sec: 15 * 60 },
  { label: 'lunch breaks (30m)', sec: 30 * 60 },
  { label: '1-hour meetings', sec: 60 * 60 },
  { label: 'commutes (~45m)', sec: 45 * 60 },
  { label: 'power naps (20m)', sec: 20 * 60 },
  { label: 'sleep cycles (90m)', sec: 90 * 60 },
  { label: 'workdays (8h)', sec: 8 * 60 * 60 },
  { label: 'nights of sleep (8h)', sec: 8 * 60 * 60 },
  { label: 'work weeks (40h)', sec: 40 * 60 * 60 },
  { label: 'Netflix binges (5h)', sec: 5 * 60 * 60 },
  { label: 'scrolling TikTok sessions (~1h)', sec: 60 * 60 },

  // Sports & Games
  { label: 'bullet chess games (1m)', sec: 60 },
  { label: '10-minute blitz chess games', sec: 10 * 60 },
  { label: '15-minute rapid chess games', sec: 15 * 60 },
  { label: 'NBA quarters (12m)', sec: 12 * 60 },
  { label: 'football halves (45m)', sec: 45 * 60 },
  { label: 'soccer penalty shootouts (~10m)', sec: 10 * 60 },
  { label: 'ice hockey periods (20m)', sec: 20 * 60 },
  { label: 'tennis sets (~40m)', sec: 40 * 60 },
  { label: 'cricket T20 innings (~90m)', sec: 90 * 60 },
  { label: 'rugby halves (40m)', sec: 40 * 60 },
  { label: 'average marathons (~4h20m)', sec: (4 * 60 + 20) * 60 },
  { label: 'Ironman triathlons (~8h)', sec: 8 * 60 * 60 },
  { label: 'F1 race durations (~1h30m)', sec: 90 * 60 },
  { label: 'Le Mans 24h race', sec: 24 * 60 * 60 },
  { label: 'Tour de France stages (~5h)', sec: 5 * 60 * 60 },
  { label: 'Super Bowl broadcasts (~4h)', sec: 4 * 60 * 60 },

  // Music & Quick References
  { label: 'pop songs (~3m30s)', sec: 3 * 60 + 30 },
  { label: 'hip hop tracks (~4m)', sec: 4 * 60 },
  { label: 'classical symphonies (~45m)', sec: 45 * 60 },
  { label: 'opera performances (~3h)', sec: 3 * 60 * 60 },
  { label: 'espresso shots (30s)', sec: 30 },
  { label: 'microwave popcorn bags (2m30s)', sec: 2 * 60 + 30 },
  { label: 'TikTok videos (1m)', sec: 60 },
  { label: 'YouTube shorts (60s)', sec: 60 },
  { label: 'YouTube tutorials (~15m)', sec: 15 * 60 },
  { label: 'podcast episodes (~45m)', sec: 45 * 60 },
  { label: 'audiobook chapters (~20m)', sec: 20 * 60 },
  { label: 'vinyl LP sides (~22m)', sec: 22 * 60 },
  { label: 'concert sets (~90m)', sec: 90 * 60 },
  { label: 'music festivals (~12h)', sec: 12 * 60 * 60 },

  // Travel
  { label: 'New York→London flights (~7h)', sec: 7 * 60 * 60 },
  { label: 'L.A.→Tokyo flights (~11h)', sec: 11 * 60 * 60 },
  { label: 'Sydney→L.A. flights (~14h)', sec: 14 * 60 * 60 },
  { label: 'Concorde London→NYC flights (~3h)', sec: 3 * 60 * 60 },
  { label: 'Eurostar London→Paris (~2h20m)', sec: (2 * 60 + 20) * 60 },
  { label: 'cross-country US train (~3d)', sec: 3 * 24 * 60 * 60 },
  { label: 'round-the-world flights (~48h)', sec: 48 * 60 * 60 },
  { label: 'Everest base camp trek (~12d)', sec: 12 * 24 * 60 * 60 },

  // Space & Science
  { label: 'ISS orbits (~92m)', sec: 92 * 60 },
  { label: 'Falcon 9 launch to orbit (~9m)', sec: 9 * 60 },
  { label: 'Starship test flights (~6m)', sec: 6 * 60 },
  { label: 'Apollo 11 round-trip (~8d)', sec: 8 * 24 * 60 * 60 },
  { label: 'Hubble telescope orbits (~96m)', sec: 96 * 60 },
  { label: 'day on Mars (~24h40m)', sec: (24 * 60 + 40) * 60 },
  { label: 'lunar days (~29.5d)', sec: Math.round(29.5 * 24 * 60 * 60) },
  { label: 'years (365d)', sec: 365 * 24 * 60 * 60 },
  { label: 'Olympiad cycles (4y)', sec: 4 * 365 * 24 * 60 * 60 },
  { label: 'Halley’s Comet orbit (76y)', sec: 76 * 365 * 24 * 60 * 60 },

  // Nature & Life
  { label: 'calendar days (24h)', sec: 24 * 60 * 60 },
  { label: 'weeks (7d)', sec: 7 * 24 * 60 * 60 },
  { label: 'fortnights (14d)', sec: 14 * 24 * 60 * 60 },
  { label: 'human pregnancies (~280d)', sec: 280 * 24 * 60 * 60 },
  { label: 'elephant pregnancies (~660d)', sec: 660 * 24 * 60 * 60 },
  { label: 'hamster lifespans (~2y)', sec: 2 * 365 * 24 * 60 * 60 },
  { label: 'cat lifespans (~15y)', sec: 15 * 365 * 24 * 60 * 60 },
  { label: 'tortoise lifespans (~100y)', sec: 100 * 365 * 24 * 60 * 60 },
  { label: 'human lifespans (~79y)', sec: 79 * 365 * 24 * 60 * 60 }
];



  const viable = CATALOG
    .map(u => ({ label: u.label, count: Math.floor(s / u.sec) }))
    .filter(x => x.count >= 1);

  const out: string[] = [];
  for (const v of viable) {
    out.push(`About ${fmt(v.count)} ${v.label}`);
    if (out.length >= 95) break;
  }

  // Fallback (very short durations)
  if (out.length === 0 && s > 0) {
    const songs = Math.max(1, Math.ceil(s / 210));
    out.push(`About ${fmt(songs)} songs (3m30s)`);
  }

  return out;
}
